import { Image } from "antd";
import React, { useEffect, useState } from "react";
import { MobileDropdown } from "./mobileDropdown";
// import { Heading } from "../../../../machinery/styled.components";
import {
  Container,
  LeftSideBar,
  VerticalLine,
  InnerContainer,
  RightContainer,
  InnerRightContainer,
  Card,
  CardInner,
  CardHeading,
  ImagesContainer,
  Heading,
  Title,
  InnerCardContainer,
  InnerCardRightContainer,
} from "./styled.components";
const CompletedProject = ({ CompletedProjects }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const [activeProject, setActiveProject] = useState(CompletedProjects[0]?._id);

  const onWindowResize = () => {
    setIsMobile(window.innerWidth <= 575);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);
  return (
    <>
      <Container>
        <InnerContainer>
          {isMobile ? (
            <MobileDropdown
              onGoingProjects={CompletedProjects}
              setActiveProject={setActiveProject}
            />
          ) : (
            <LeftSideBar>
              {CompletedProjects.map((_project) => {
                return (
                  <Heading
                    style={{
                      color: activeProject == _project._id ? "#F08700" : "",
                      border:
                        activeProject == _project._id
                          ? "1.5px solid #F08700"
                          : "0.5px solid #e0e0e0",
                      borderRadius: "10px",
                      padding: "12px 14px",
                      boxShadow:
                        activeProject == _project._id
                          ? "0 0 0 3px rgba(240,135,0,0.15)"
                          : "",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => setActiveProject(_project._id)}
                  >
                    {_project.title}
                  </Heading>
                );
              })}
            </LeftSideBar>
          )}

          <VerticalLine />
        </InnerContainer>
        <RightContainer>
          <InnerRightContainer>
            {CompletedProjects.map((proj_) => {
              if (activeProject == proj_._id) {
                return (
                  <>
                    <Card>
                      <CardInner>
                        <InnerCardContainer>
                          <CardHeading>Project:</CardHeading>
                          <CardHeading>Description:</CardHeading>
                          <CardHeading>Status:</CardHeading>
                          {/* <CardHeading>Cost:</CardHeading> */}
                        </InnerCardContainer>
                        <InnerCardRightContainer>
                          <Title>{proj_.title}</Title>
                          <Title>{proj_.description}</Title>
                          <Title>{proj_.status}</Title>
                          {/* <Title>{proj_.amount}</Title> */}
                        </InnerCardRightContainer>
                      </CardInner>
                    </Card>
                    <ImagesContainer>
                      {proj_.images.map((img_) => {
                        return (
                          <a href={img_}>
                            <Image src={img_} alt="img" />
                          </a>
                        );
                      })}
                    </ImagesContainer>
                  </>
                );
              }
              return;
            })}
          </InnerRightContainer>
        </RightContainer>
      </Container>
    </>
  );
};

export default CompletedProject;
